import { useTheme } from 'styled-components';

export const NewIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.34095 14.4838C5.34095 15.3219 6.01905 16 6.85714 16C7.69524 16 8.37333 15.3219 8.37333 14.4838H5.34095ZM12.099 11.2914V6.85714C12.099 4.38095 10.3848 2.30857 8.06857 1.76V1.21143C8.06857 0.540952 7.52762 0 6.85714 0C6.18667 0 5.64571 0.540952 5.64571 1.21143V1.76C3.32952 2.30857 1.61524 4.38095 1.61524 6.85714V11.2914L0 12.9067V13.7143H13.7143V12.9067L12.099 11.2914ZM9.90476 8.38857H7.61905V10.6743H6.09524V8.38857H3.80952V6.85714H6.09524V4.57143H7.61905V6.85714H9.90476V8.38857Z"
        fill={theme.main.deepBlue}
      />
    </svg>
  );
};
